import React from 'react';
import { BasePage, NetworkIndicator } from 'design-system';
import { Grid, makeStyles, createStyles } from '@material-ui/core';

export const loadingMessage = 'Obteniendo datos de cotización...';

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      height: 'calc(100vh - 56px)',
    },
    loadingWrapper: {
      width: '90%',
      display: 'inline-block',
    },
  }),
);

const LoadingSubScreen = (): JSX.Element => {
  const classes = useStyles();
  return (
    <BasePage padding={0} title="">
      <Grid
        className={classes.content}
        container
        alignItems="center"
        justifyContent="center"
      >
        <div className={classes.loadingWrapper}>
          <NetworkIndicator
            message="Obteniendo datos de cotización..."
            requesting
          />
        </div>
      </Grid>
    </BasePage>
  );
};

export default LoadingSubScreen;
